export default {
  title: 'Crea tu Aplicación',
  description:
    'Bienvenido a Inbox Bridge, tu solución SaaS de gestión de correo electrónico.',
}
